













import { defineComponent, toRefs } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { DocumentStatsType } from '../../api/types/document-stats-type';
import { DashboardWidgetHeaderColor } from '../../../types/enums/dashboard-widget-header-color';
import DashboardWidget from '../../../components/DashboardWidget.vue';
import { WidgetHelper } from '../helpers/widget.helper';
import { useLoadDocumentStats } from '../composables/load-document-stats.composable';

export default defineComponent({
  components: {
    DashboardWidget,
  },
  props: {
    showAll: {
      type: Boolean,
    },
  },
  setup(props) {
    const { showAll } = toRefs(props);
    const { isLoading, isSuccess, documentCount } = useLoadDocumentStats(
      DocumentStatsType.Sent,
      showAll
    );
    return {
      isLoading,
      isSuccess,
      documentCount,
      DashboardWidgetHeaderColor,
      countTitle: WidgetHelper.getCountTitle,
      t,
    };
  },
});
